import React, { useEffect } from 'react'
import mitt from 'mitt'

export const BusContext = React.createContext(null)

export default function useBus() {
  return React.useContext(BusContext)
}

export function useListener(name, fn) {
  const bus = useBus()
  React.useEffect(() => {
    bus.on(name, fn)
    return () => {
      bus.off(name, fn)
    }
  }, [bus, name, fn])
}

export function Provider({ children }) {
  const [bus] = React.useState(() => mitt())
  useEffect(() => {
    window.bus = bus;
    return () => {
        // 清除window对象上的bus
        delete window.bus;
    }
  }, [bus])
  return <BusContext.Provider value={bus}>{children}</BusContext.Provider>
}
